import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface QueryRequest {
  dateFrom: string | null;       // 請款日期起 (ISO date)
  dateTo: string | null;         // 請款日期迄
  docNoFrom: string;             // 請款單號起
  docNoTo: string;               // 請款單號迄
  deptFrom: string;              // 歸屬部門起
  deptTo: string;                // 歸屬部門迄
  vendorFrom: string;            // 廠商/員工代號起
  vendorTo: string;              // 廠商/員工代號迄
  needFrom: string | null;       // 需要日期起
  needTo: string | null;         // 需要日期迄
  chkDate1From: string | null;   // 支票到期日(1)起
  chkDate1To: string | null;     // 支票到期日(1)迄
  chkDate2From: string | null;   // 支票到期日(2)起
  chkDate2To: string | null;     // 支票到期日(2)迄
  entryEmpFrom: string;          // 入單人員起
  entryEmpTo: string;            // 入單人員迄
  approvalStatus: number;        // 1=已核准 2=未核准 3=未沖帳 4=全部
  reportTypes: string[];         // ["date","dept","doc","vendor"]
  sortBy: string;                // date/dept/doc/vendor
}

export interface PaymentDetailRow {
  docNo: string;
  docDate: string | null;
  vendorCode: string;
  vendorName: string;
  chkDate1: string | null;
  categoryCode: string;
  categoryName: string;
  needDate: string | null;
  currency: string;
  payTypeCode: string;
  payTypeName: string;
  chkDate2: string | null;
  deptCode: string;
  deptName: string;
  holdFlag: boolean;
  approvalFlag: string;
  entryEmpCode: string;
  entryEmpName: string;
  unapprovedMark: string;
  invoiceNo: string;
  invoiceDate: string | null;
  batchNo: string;
  batchSeq: number;
  detailDept: string;
  expenseName: string;
  expenseCompany: string;
  shipNo: string;
  amountExTax: number;
  taxAmount: number;
  amountInTax: number;
}

export interface QueryResponse {
  details: PaymentDetailRow[];
  totalCount: number;
  approvalLabel: string;
}

export interface LookupResult {
  code: string;
  name: string;
}

// ============================================================
// API Client
// ============================================================

export const h311Api = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/h311/query', req);
    return res.data;
  },

  async lookup(type: string, code: string): Promise<LookupResult> {
    const res = await apiClient.get(`/api/h311/lookup/${type}/${encodeURIComponent(code)}`);
    return res.data;
  },
};
